module.exports = __webpack_public_path__ + "img/kr-card-bottom-4.0a2c1f2.png";